<template>
  <div id="top">
    <b-alert :show="!event.published" variant="warning">You are previewing an event listing that has not been published yet.<br>To publish, visit the <a :href="`/planner/events/${event.id}/edit`">event editor</a> and change the status from <strong>planning</strong> to <strong>published</strong>. </b-alert>
    <b-card no-body class="mt-3">
      <b-card-header class="d-lg-none">
        <h5 class="pb-0 mb-0">{{event.title}}</h5>
      </b-card-header>
      <b-card-body>
        <div class="row">
          <div class="col">
            <div class="d-none d-lg-block">
              <h4 class="pb-1 mb-0 pt-1">{{event.title}}
                <small v-if="event.event_label" class="ml-2">
                  <!-- <span class="badge" :style=`background-color: '${event.event_label.color}'; color: '${event.event_label.text_color}'`>{{event.event_label.name}}</span> -->
                  <span class="badge" :style="`background-color: ${event.event_label.color}; color: ${event.event_label.text_color}`">{{event.event_label.name}}</span>
                </small>
              </h4>
            </div>

            <div class="d-lg-none pt-3" />
             
            <span class="text-muted">{{format.datetime(event.start_time)}}</span>
            <br>
            <a :href="storeLink">@ {{event.store.name}}</a>
          </div>

          <div class="col-auto">
            <a :href="storeLink"><img :src="event.store.avatar_path" width=80 height=80 /></a>
          </div>
        </div>

        <hr class="mt-3">

        <ReserveButton :event="event" />

        <p class="text-muted text-center mb-0">
          <small>
            <span>You may reserve up to <strong>{{event.max_party_size}} spots</strong> in this event.</span>
            <div v-if="event.price > 0">
              <span v-if="Date.now() < Date.parse(event.local_rsvp_by_datetime)"><br>Free cancellation before {{format.datetime(event.local_rsvp_by_datetime)}}.</span>
              <span v-else><br>The free cancellation period for this event has passed, so you may be charged even if you do not attend.<br>Questions? Please reach out to <em>{{event.store.name}}</em> for more information about their attendance and refund policy.</span>
            </div>
          </small>
        </p>
        
      </b-card-body>

      <b-card-footer :style="`border-right: 5px solid ${event.event_label ? event.event_label.color : '#ddd'}; border-left: 5px solid ${event.event_label ? event.event_label.color : '#ddd'};`">
        <div class="row">
          <div class="col">
            <QueueStatusOrbs :stats=event.stats />
          </div>
        </div>
      </b-card-footer>
    </b-card>

    <b-card v-if="event.guests_allowed && !event.reservations_closed" class="text-center mt-2">
      <a :href="guestReservationLink">Reserve as a guest without signing in.</a>
    </b-card>

    <EventProgressBar :stats="event.stats" />

    <b-card class="mt-2">
      <div v-html="marked(event.description)" />
    </b-card>

    <div class="text-center mt-2"><a href="#top">Return to top</a></div>

  </div>
</template>

<script>
import QueueStatusOrbs  from "./QueueStatusOrbs"
import ReserveButton    from "./ReserveButton"
import EventProgressBar from "./EventProgressBar"

export default {
  name: "Event",
  props: ["dataEvent"],
  components: { QueueStatusOrbs, ReserveButton, EventProgressBar },
  data() {
    return { event: undefined }
  },
  created() {
    this.event = JSON.parse(this.dataEvent)
  },
  computed: {
    storeLink() { return `/stores/${this.event.store.slug}` },
    guestReservationLink() {
      return `/guests/new?event_id=${this.event.id}`
    },
  }
}
</script>